import $ from 'jquery';
// import {dependency} from "../utils/request";
import _ from 'lodash';

export default function headerSection() {

	// dependency('https://cdnjs.cloudflare.com/ajax/libs/tilt.js/1.2.1/tilt.jquery.min.js').then(function () {
	// 	const menuTilt = $('.menu .bg').tilt({
	// 		perspective: 1000,
	// 		reset: false,
	// 		maxTilt: 50,
	// 		speed: 200,
	// 	});
	//
	// 	const tilt = $('#content > .tilt').tilt({
	// 		perspective: 1000,
	// 		reset: false,
	// 		maxTilt: 50,
	// 		speed: 200,
	// 	});
	// });

	function rotate (event, el)
	{
		let x = event.clientX;
		let y = event.clientY;
		let w = window.innerWidth;
		let h = window.innerHeight;
		let midpoint = w / 2;
		let midpointY = h / 2;
		let pos = x - midpoint;
		let posY = y - midpointY;
		let val = (pos / midpoint) * 5;
		let valY = (posY / midpointY) * 10;
		el.style.transform = "perspective(1000px) rotateY(" + val + "deg) rotateX(" + valY*-1 + "deg)";
	}

	if ($('#content .tilt').length) {
		document.addEventListener("mousemove", _.throttle(function(event)
		{
			rotate(event, document.querySelector('#content .tilt'));
			rotate(event, document.querySelector('.menu .bg'));
		}, 30), false);
	}
}



// WEBPACK FOOTER //
// ./source/scripts/sections/tilt.js